import React from 'react';
import {
  Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import HeartsList from './hearts-list';
import MessagesList from './messages-list';

const LoveboxTable = ({ activeTab, onTabChange, selectedLovebox }) => {
  const toggle = (tab) => {
    if (activeTab !== tab) {
      onTabChange(tab);
    }
  };

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => (toggle('1'))}
          >
            Messages
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => (toggle('2'))}
          >
            Hearts
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <div>
            <MessagesList
              boxId={selectedLovebox}
            />
          </div>
        </TabPane>
        <TabPane tabId="2">
          <div>
            <HeartsList
              selectedLovebox={selectedLovebox}
            />
          </div>
        </TabPane>
      </TabContent>
    </div>
  );
};

// eslint-disable-next-line import/prefer-default-export
export { LoveboxTable };



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/table/lovebox-table.js